import React, { useState, useEffect, useCallback } from "react";
import logo from "assets/img/logo/logo_aig_login-2.png";
import FormDatosFacturacion from "./DatosFacturacionPymes";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { listarECivilesFetch, listarGenerosFetch, listarProvinciasFetch, listarCiudadesFetch, fetchConsultarIdentificacionAP, recuperarDatosFacturacionFetch, setRecuperarDatosFacturacion } from "../../../../redux/actions/aCotizacion";
import LoadingScreen from "react-loading-screen";
import { FetchTotalesCabeceraCotizadores } from "../../../../redux/actions/ACarritoProductos";
import { FetchRenovacionItem } from "../../redux/aRenovaciones";

const ContainerDatosFacturacionPymes = (props) => {
  const {
    location,
    listarEstadosCiviles,
    listarGeneros,
    listarProvincias,
    listarCiudades,
    consultarIdentificacionProp,
    datosFacturacion,
    datosFacturacionDirecta,
    actualizarTotalesCabecera,
    catalogos,
    datosIdentificacion,
    dataFacturacion,
    dataFacturacion2
  } = props;

  const [cargando, setCargando] = useState(true);
  const [loadingPagadores, setLoadingPagadores] = useState(false);
  const [loadingText, setLoadingText] = useState("");
  const [esRenovacionDirecta, setEsRenovacionDirecta] = useState(false);
  const [renovacionIdLocal, setRenovacionIdLocal] = useState(null);

  const cargarDatosDesdeRenovacion = useCallback(async (renovacionId) => {
    try {
      const data = await FetchRenovacionItem(renovacionId);

      if (data && data.dataRenovacion) {
        const renovacion = data.dataRenovacion;
        const datosContratante = renovacion.reDatosContratante || {};

        // Los campos ya vienen con nombres directos del servicio
        const identificacion = datosContratante.identificacion || "";
        const tipoDocumento = datosContratante.codTipodocumento || "";

        // Nombres y apellidos ya vienen separados del servicio
        const cliNombres = datosContratante.cliNombres || "";
        const cliApellidos = datosContratante.cliApellidos || "";

        // Mapear provincia y ciudad (vienen como objetos {value, label})
        const provincia = datosContratante.provincia || "";
        const ciudad = datosContratante.ciudad || "";

        // Extraer datos del producto para ValoresRenovacion
        const datosProducto = renovacion.reDatosProducto || {};
        const ramo = (datosProducto.reRamoProducto === 'PYMES' ? 'PYMES' : datosProducto.reRamo) || "PYMES";

        // Construir objeto compatible con campos del formulario DatosFacturacionPymes
        const datosFacturacionCompatible = {
          transaccion: true,
          _id: renovacionId,
          carDatosContratante: {
            cliIdentificacion: identificacion,
            cliTipoDocumento: tipoDocumento,
            cliNombres: cliNombres,
            cliApellidos: cliApellidos,
            cliEmail: datosContratante.correo || "",
            cliDireccion: datosContratante.direccion || "",
            cliCelular: datosContratante.celular || "",
            cliCodGenero: datosContratante.codGenero || "",
            cliCodEstadoCivil: datosContratante.codEstadoCivil || "",
            cliFechaNacimiento: datosContratante.fechaNacimiento || null,
            mongoIdentificador: datosContratante.id || "",
            provincia: provincia,
            ciudad: ciudad,
          },
          carDescripcionRamo: ramo,
          ramo: ramo,
          // Datos de la renovación original para que ValoresRenovacion identifique ramo
          reDatosProducto: datosProducto,
          renovacionId: renovacionId,
          esRenovacionDirecta: true,
        };

        // Despachar al store de Redux como si fuera la respuesta del carrito
        datosFacturacionDirecta(datosFacturacionCompatible);

        // Cargar ciudades si ya hay provincia seleccionada
        if (provincia && provincia.value) {
          listarCiudades(provincia.value);
        }

        setEsRenovacionDirecta(true);
        setRenovacionIdLocal(renovacionId);
      }
    } catch (error) {
      console.error('Error al cargar datos de renovación:', error);
    }
  }, [datosFacturacionDirecta, listarCiudades]);

  useEffect(() => {
    const fetchInicial = async () => {
      await listarEstadosCiviles();
      await listarGeneros();
      await listarProvincias();

      const queryParams = new URLSearchParams(location.search);
      const renovacionIdURL = queryParams.get('renovacionId');
      const idCarritoURL = queryParams.get('id');

      if (renovacionIdURL) {
        // Flujo PYMES sin carrito: cargar datos directamente desde la renovación
        await cargarDatosDesdeRenovacion(renovacionIdURL);
      } else if (idCarritoURL) {
        // Flujo con carrito existente (legacy)
        const datosJSON = {
          empresa: "AIGMETROPOLITANA",
          plataforma: "WEB",
          idCarrito: idCarritoURL
        };
        await datosFacturacion(datosJSON);
      }

      setCargando(false);
    };

    fetchInicial();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (dataFacturacion2 !== undefined && dataFacturacion2 !== "") {
      let param = {
        pathIcono: dataFacturacion2.pathIconoTotalesCabecera ? dataFacturacion2.pathIconoTotalesCabecera : "",
        totalItems: dataFacturacion2.numItemsCarrito ? dataFacturacion2.numItemsCarrito : "0",
        totalPrima: (dataFacturacion2.carValoresTotales && dataFacturacion2.carValoresTotales.primaTotal) ? dataFacturacion2.carValoresTotales.primaTotal : "0.00",
        ramoCotizador: dataFacturacion2.carDescripcionRamo ? dataFacturacion2.carDescripcionRamo : "",
      }

      // Actualizamos cabecera solo en flujo de carrito normal
      if (!esRenovacionDirecta) {
        actualizarTotalesCabecera(param);
      }
    }
    // eslint-disable-next-line
  }, [dataFacturacion2, esRenovacionDirecta]);

  const onChangeProvincia = async (param) => {
    await listarCiudades(param);
  };

  const consultarIdentificacion = async (params) => {
    await consultarIdentificacionProp(params);
  };

  const handleLoadingChange = (loading, text = "") => {
    setLoadingPagadores(loading);
    setLoadingText(text);
  };

  const textosCargando = () => {
    if (dataFacturacion.recuperarDatosFacturacionIsLoading)
      return "Cargando información para facturación...";
    if (cargando)
      return "Cargando información para el pago...";
    if (catalogos.listarCiudadesIsLoading)
      return "Cargando catálogo de ciudades...";
    if (datosIdentificacion.consultarIdentificacionAPIsLoading)
      return "Cargando datos del cliente...";
    if (loadingPagadores)
      return loadingText || "Procesando...";
    return "";
  };

  return (
    <LoadingScreen
      loading={cargando || catalogos.listarCiudadesIsLoading || datosIdentificacion.consultarIdentificacionAPIsLoading || dataFacturacion.recuperarDatosFacturacionIsLoading || loadingPagadores}
      bgColor="#f1f1f1"
      spinnerColor="#001871"
      textColor="#676767"
      logoSrc={logo}
      text={textosCargando()}
    >
      <main className="cr-app bg-light">
        <div className="cr-content container-fluid">
          <div className="container-body-spaces">
            {!cargando &&
              <FormDatosFacturacion
                onChangeProvincia={onChangeProvincia}
                consultarIdentificacion={consultarIdentificacion}
                dataFacturacion={dataFacturacion.datosFacturacion}
                onLoadingExternoChange={handleLoadingChange}
                esRenovacionDirecta={esRenovacionDirecta}
                renovacionId={renovacionIdLocal}
              />
            }
          </div>
        </div>
      </main>
    </LoadingScreen>
  );
};

const mapStateToProps = state => ({
  datosIdentificacion: state.datosIdentificacionAP,
  catalogos: state.catalogosCotizacion,
  dataFacturacion: state.dataFacturacion,
  dataFacturacion2: state.dataFacturacion.datosFacturacion
});

const mapDispatchToProps = dispatch => {
  return {
    listarEstadosCiviles: () => dispatch(listarECivilesFetch()),
    listarGeneros: () => dispatch(listarGenerosFetch()),
    listarProvincias: () => dispatch(listarProvinciasFetch()),
    listarCiudades: (provincia) => dispatch(listarCiudadesFetch(provincia)),
    consultarIdentificacionProp: datos => dispatch(fetchConsultarIdentificacionAP(datos)),
    datosFacturacion: (data) => dispatch(recuperarDatosFacturacionFetch(data)),
    datosFacturacionDirecta: (data) => dispatch(setRecuperarDatosFacturacion(data)),
    actualizarTotalesCabecera: (param) => dispatch(FetchTotalesCabeceraCotizadores(param)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ContainerDatosFacturacionPymes)
);
